import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import cx from "classnames"
import s from "./GameOver.module.scss"
import store from "store"
import { setState } from "store/game"
import EventPubSub from "scripts/util/EventPubSub"
import useQuery from "hooks/useQuery";

GameOver.defaultProps = {}

const translate = {
  youDidIt : {
    en: {
      img: require("assets/images/en/gameOver/you-did-it.png").default,
      alt: "You did it!"
    },
    es: {
      img: require("assets/images/es/gameOver/you-did-it.png").default,
      alt: "lo lograste!"
    },
  },
  outOfTime : {
    en: {
      img: require("assets/images/en/gameOver/out-of-time.png").default,
      alt: "Out of time..."
    },
    es: {
      img: require("assets/images/es/gameOver/out-of-time.png").default,
      alt: "se acabo el tiempo..."
    },
  },
}

export default function GameOver({ active }) {
  const { time, points, winner } = useSelector((state) => state.game)
  const [displayTime, setDisplayTime] = useState(1)
  const lang = useQuery().get("lang") || "en";

  useEffect(() => {
    if (active) {
      setTimeout(() => {
        setDisplayTime(time)
      }, 3000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active])

  useEffect(() => {
    if (active && displayTime > 0) {
      setTimeout(() => {
        if (time > 0) {
          store.dispatch(setState({time: time - 1}))
          store.dispatch(setState({points: points + 10}))
          setDisplayTime(displayTime - 1)
        }
      }, 100)
    } else if (active) {
      setTimeout(() => {
        EventPubSub.emit('game', 'gameDestroy')
      }, 3000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayTime])

  return (
    <div className={cx(s.GameOver, { [s.active]: active })}>
      <img
        src={winner ? translate.youDidIt[lang].img : translate.outOfTime[lang].img}
        alt={winner ? translate.youDidIt[lang].alt : translate.outOfTime[lang].alt}
      />
    </div>
  )
}
